/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-05 15:53:37                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-10 15:53:18                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Styles
  * AdminLeftNav: Admin left navigation bar
*/

/* Imports */
import { AdjustmentsVerticalIcon, ArrowUturnLeftIcon, BuildingOfficeIcon, CircleStackIcon, ClipboardDocumentCheckIcon, FolderIcon, ShareIcon, ShieldCheckIcon, TruckIcon, UserGroupIcon, WrenchScrewdriverIcon } from "@heroicons/react/24/outline";
import { NavLink } from "react-router-dom";
import { t } from "i18next";
/***/

/* Styles */
import "./AdminLeftNav.scss";
import { Typography } from "@material-tailwind/react";
/***/

/**
* AdminLeftNav: Admin left navigation bar
*/
export default function AdminLeftNav() {
  const menuItems = [
    {link: "interventions", icon: <TruckIcon/>, label: t("admin:menu.interventions")},
    {link: "prospects", icon: <ShareIcon/>, label: t("admin:menu.visits")},
    {link: "users", icon: <UserGroupIcon/>, label: t("admin:menu.users")},
    {link: "customers", icon: <BuildingOfficeIcon/>, label: t("admin:menu.customers")},
    {link: "compinfos", icon: <FolderIcon/>, label: t("admin:menu.customField")},
    {link: "settings", icon: <AdjustmentsVerticalIcon/>, label: t("admin:menu.settings")},
    {link: "odoo", icon: <CircleStackIcon/>, label: t("admin:menu.odoo")},
    {link: "tools", icon: <WrenchScrewdriverIcon/>, label: t("admin:menu.tools")},
    {link: "auto-diag", icon: <ClipboardDocumentCheckIcon/>, label: t("admin:menu.autoDiag")},
    {link: "diag-secu", icon: <ShieldCheckIcon/>, label: t("admin:menu.diagSecu")}
  ];
  
  return (
    <nav className="admin-leftnav">
      <div className="menu-list">
        {menuItems.map((item, i) => (
          <NavLink to={item.link} className="menu-item" key={`item-${i}`}>
            {item.icon}
            <Typography>{item.label}</Typography>
          </NavLink>
        ))}
      </div>

      <div className="menu-bottom">
        <NavLink to="/" className="menu-item">
          <ArrowUturnLeftIcon/>
          <Typography>{t("admin:menu.backToSite")}</Typography>
        </NavLink>
      </div>
    </nav>
  );
}
/***/
